import React from "react";
import {
  Grid,
  Box,
  Typography,
  Checkbox,
  Autocomplete,
  TextField,
  FormControl,
  FormHelperText,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CurrenciesSettings = ({ formik, setTouched, currencies }) => {
  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };

  const handleChangeCurrency = (e, newValue) => {
    setTouched(true);
    formik.setFieldValue("currencies", newValue);
  };

  return (
    <Grid
      container
      direction="column"
      rowSpacing="16px"
      justifyContent="flex-start"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "20px 30px 36px 30px",
      }}
    >
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            marginBottom: "8px",
          }}
        >
          Currencies Settings
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Bank Currencies
          </Typography>
          <FormControl>
            <Autocomplete
              size="small"
              disableClearable={true}
              id="bank-currencies"
              placeholder="SELECT CURRENCY"
              multiple
              limitTags={2}
              groupBy={() => "SELECT CURRENCY"}
              value={formik.values.currencies}
              onChange={handleChangeCurrency}
              options={currencies}
              disableCloseOnSelect
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option, { selected }) => (
                <Box
                  component="li"
                  {...props}
                  sx={{ paddingLeft: "0px", marginLeft: "0px" }}
                >
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    sx={{
                      height: "28px",
                      width: "32px",
                    }}
                    checked={selected}
                  />
                  {option.name}
                </Box>
              )}
              style={{ width: "480px" }}
              renderInput={(params) => (
                <TextField
                  sx={{
                    ".MuiFormLabel-root": { color: "#50566E" },
                    "& .MuiInputBase-root": {
                      backgroundColor: "#ffffff",
                      borderRadius: "4px",
                      color: "#1C2238",
                      fontSize: ".875rem",
                      "& fieldset": {
                        borderColor: "#D3D8E3",
                      },
                      "&:hover fieldset": {
                        borderColor: "#D3D8E3",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#D3D8E3",
                      },
                    },
                  }}
                  size="small"
                  variant="outlined"
                  {...params}
                />
              )}
            />
          </FormControl>
          {formik.touched.currencies && Boolean(formik.errors.currencies) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.currencies}
            </FormHelperText>
          )}
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Clearance Code
          </Typography>
          <TextField
            name="clearanceCode"
            value={formik.values.clearanceCode}
            onChange={handleChange}
            error={
              formik.touched.clearanceCode &&
              Boolean(formik.errors.clearanceCode)
            }
            helperText={
              formik.touched.clearanceCode && formik.errors.clearanceCode
            }
            sx={{
              width: "120px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              "& .MuiFormHelperText-root": {
                width: "max-content",
              },
              ...(formik.errors.clearanceCode && { marginBottom: "10px" }),
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CurrenciesSettings;
